module.exports = __webpack_public_path__ + "img/instruction_3.5ed55a03.svg";